export * from './student-comment.model';
export * from './student-comment-popup.service';
export * from './student-comment.service';
export * from './student-comment-dialog.component';
export * from './student-comment-delete-dialog.component';
export * from './student-comment-detail.component';
export * from './student-comment.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/index.ts